import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom';
import { Button, Typography, FormControl, Grid, InputLabel, Select, MenuItem, Paper, Divider, FormControlLabel, Checkbox, FormGroup } from '@material-ui/core'
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'; // single carad element for collecting card number, postal etc
import axios from 'axios';
//import useStyles from './styles'
import convertCities from './helpers/convertCities';
import LockIcon from '@material-ui/icons/Lock';
import { Link } from 'react-router-dom';

const Payment = ({ user, location, signedIn }) => { //Puslinch - Flamborough - Halton Hills will be divided out to Puslinch - Halton Hills, and then Flamborough seperate because its on ITSO.
    const allRegions = ['Kitchener', 'Waterloo', 'Cambridge - Hespeler - Preston', 'Guelph', 'Woolwich - Wellesley - Wilmot - N Dumfies - Flamborough', 'Puslinch - Halton Hills', 'Guelph/Eramosa - Center Wellington - Wellington North - Erin - Minto']
    const ITSOCities = ['Kitchener', 'Waterloo', 'Cambridge - Hespeler - Preston', 'Hamilton Region - Stoney Creek',]
    const PropTXCities = ['Guelph', 'Puslinch - Halton Hills', 'Guelph/Eramosa - Center Wellington - Wellington North - Erin - Minto', 'Brantford', 'Brant County', 'Woolwich - Wellesley - Wilmot - N Dumfies', 'Woodstock', 'Oxford County']
    // , 'Hamilton Region - Stoney Creek', 'Brantford', 'Brant County', 'Woolwich - Wellesley - Wilmot - N Dumfies', 'Woodstock', 'Oxford County'
    const [cities, setCities] = useState([])
    const [subscriptionType, setSubscriptionType] = useState(1)
    const [paySchedule, setPaySchedule] = useState(location.state.paySchedule)
    const [tier, setTier] = useState(1) // 1, 2 or 3 for single, triple, all
    const [price, setPrice] = useState(location.state.locationPrice)
    const [subscribedClicked, setSubscribedClicked] = useState(false)
    const [board, setBoard] = useState('PropTX') // ITSO or PropTX
    const [paymentError, setPaymentError] = useState({ er: false, mess: '' })
    useEffect(() => {
        if (!location) {
            return
        }
        const { locationPrice } = location.state
        if (locationPrice === 10) {
            setSubscriptionType(3)
            setTier(2)
            setPaySchedule('monthly')
            setPrice(10)
        }
        if (locationPrice === 15) {
            setSubscriptionType(5)
            setTier(3)
            setPaySchedule('monthly')
            setPrice(15)
            setCities(allRegions)
        }
        if (locationPrice === 49) {
            setSubscriptionType(2)
            setTier(1)
            setPaySchedule('yearly')
            setPrice(49)
        }
        if (locationPrice === 99) {
            setSubscriptionType(4)
            setTier(2)
            setPaySchedule('yearly')
            setPrice(99)
        }
        if (locationPrice === 149) {
            setSubscriptionType(6)
            setTier(3)
            setPaySchedule('yearly')
            setPrice(149)
            setCities(allRegions)
        }
        if (locationPrice === 5) {
            setSubscriptionType(1)
            setTier(1)
            setPaySchedule('monthly')
            setPrice(5)
        }// eslint-disable-next-line
    }, [location])

    useEffect(() => {
        if (paySchedule === 'monthly' && tier === 1) {
            setPrice(5)
            setCities([])
        }
        if (paySchedule === 'monthly' && tier === 2) {
            setPrice(10)
            setCities([])
        }
        if (paySchedule === 'monthly' && tier === 3) {
            setPrice(15)
            setCities(allRegions)
        }
        if (paySchedule === 'yearly' && tier === 1) {
            setPrice(49)
            setCities([])
        }
        if (paySchedule === 'yearly' && tier === 2) {
            setPrice(99)
            setCities([])
        }
        if (paySchedule === 'yearly' && tier === 3) {
            setPrice(149)
            setCities(allRegions)
        }// eslint-disable-next-line
    }, [paySchedule, tier])

    // console.log('payschedule', paySchedule, 'tier', tier, 'subscriptionType', subscriptionType)
    const CARD_OPTIONS = {
        iconStyle: "solid",
        style: {
            base: {
                iconColor: "black",
                color: "black",
                fontWeight: 500,
                fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
                fontSize: "16px",
                fontSmoothing: "antialiased",
                ":-webkit-autofill": { color: "black" },
                "::placeholder": { color: "gray" }
            },
            invalid: {
                iconColor: "#B33A3A",
                color: "#B33A3A"
            }
        }
    }

    const [success, setSuccess] = useState(false)
    const stripe = useStripe(); // returns a a reference to the stripe instance that was passed to the provider.
    // use this stripe reference to interact with the stripe API, tokens, redirects
    const elements = useElements(); // useful for locating and accessing mounted elements on the page
    // has a getElement method which returns a reference to the element

    const handleChangePaySched = (e) => {
        setPaySchedule(e.target.value)
    }
    const handleChangeTier = (e) => {
        setTier(e.target.value)
    }

    const toggleCities = (e) => {
        const target = e.target.checked; // true or false
        const name = e.target.name; // === 'Guelph'
        if (target) {
            setCities([...cities, name]);
        } else {
            setCities(cities.filter(city => city !== name));
        }
    }

    const renderCities = () => {
        return allRegions.map(city => {
            return <FormControlLabel key={city} control={<Checkbox name={city} disabled={(tier === 3) || (tier === 1 && cities.length >= 1) || (tier === 2 && cities.length >= 3)} color="primary" checked={cities.includes(city)} />} label={`${city}`} />
        })
    }
    // console.log('cities', cities)

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubscribedClicked(true)
        if (!stripe || !elements) { // make sure they've rendered....
            return;
        }
        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
            billing_details: {
                email: user.email
            }
        })
        if (error) {
            alert(error.message)
            setPaymentError({ er: true, mess: error.message })
        } else {
            const res = await axios.post('/stripe/payment', { payment_method: paymentMethod.id, user, subscriptionType })
            const { clientSecret, subscriptionId, stripeId, raw } = res.data
            console.log('res.data', res.data)
            // console.log('consol logging error - raw.message', raw.message)
            if (!raw) {
                stripe.confirmCardPayment(clientSecret).then(result => {
                    if (result.error) {
                        console.log(result.error.message)
                        setPaymentError({ er: true, mess: result.error.message })
                    } else {
                        setSuccess(true)
                        axios.post('/stripe/confirmed', {
                            cities: convertCities(cities),
                            subscriptionType,
                            user,
                            subscriptionId,
                            stripeId,
                            board
                        })
                    }
                })
            } else {
                console.log(res.data)
                try {
                    alert(raw.message)
                    setPaymentError({ er: true, mess: raw.message })
                } catch (error) {
                    setPaymentError({ er: true, mess: 'There was an error' })
                }

            }

        }
    }
    const renderSelectMessage = () => {
        if (tier === 1) {
            return "Select 1 city or region. Click Reset or change tier to change your choice."
        }
        if (tier === 2) {
            return "Select 3 cities or regions. Click Reset or change tier to change your choice."
        }
        if (tier === 3) {
            return "You have selected all of the cities and regions. Click Reset or change tier to change your choice."
        }
    }
    const handleReset = () => {
        if (tier !== 3) {
            setCities([])
        }
    }

    const monthOrYear = () => {
        return paySchedule === 'monthly' ? 'month' : 'year'
    }

    const renderCityText = () => {
        return cities.map(city => <li key={city}>{city}</li>)
    }

    const convertTierToString = tier => {
        switch (tier) {
            case 1:
                return 'Single';
            case 2:
                return 'Triple';
            case 3:
                return 'All Tier';
            default:
                return tier
        }
    }

    return (
        <>
            {!success ?
                <>
                    <Typography variant='h6'>Please confirm subscription details</Typography>
                    {!signedIn ? <Typography variant="h5" color='secondary'>You must be signed in to subscribe. You do not need to create an account, just <Link to='/pricing' style={{ color: 'red', fontWeight: 'bold' }}>sign in</Link> with either Google or Facebook</Typography> : ''}
                    <FormControl style={{ minWidth: 183 }}>
                        <InputLabel id="board" >Board</InputLabel>
                        <Select
                            id="board"
                            value={board}
                            onChange={(e) => setBoard(e.target.value)}
                        >
                            <MenuItem value={'PropTX'}>PropTX</MenuItem>
                            <MenuItem value={'ITSO'}>ITSO</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl style={{ minWidth: 183 }}>
                        <InputLabel id="paymentSchedule">Payment Schedule</InputLabel>
                        <Select
                            id="pay-schedule"
                            value={paySchedule}
                            onChange={handleChangePaySched}
                            defaultValue={paySchedule}
                        >
                            <MenuItem value={'monthly'}>Monthly</MenuItem>
                            <MenuItem value={'yearly'}>Yearly</MenuItem>
                        </Select>
                    </FormControl>
                    <><>
                        <FormControl style={{ minWidth: 183 }}>
                            <InputLabel id="tier">Tier</InputLabel>
                            <Select
                                id="tier"
                                value={tier}
                                onChange={handleChangeTier}
                            >
                                <MenuItem value={1}>Single</MenuItem>
                                <MenuItem value={2}>Triple</MenuItem>
                                <MenuItem value={3}>All</MenuItem>
                            </Select>

                        </FormControl></>
                        <Typography variant="h6" display="inline" style={{ verticalAlign: 'bottom', paddingLeft: 10 }}>
                            Price: ${price} per {monthOrYear()}
                        </Typography>
                        <br />
                        <br />
                        <Divider />
                        <br />
                        <Typography variant="h6">{renderSelectMessage()}</Typography>
                        <FormGroup row onClick={e => toggleCities(e)} >
                            {renderCities()}
                        </FormGroup>
                        <Button color="secondary" variant='outlined' onClick={handleReset}>Reset</Button>
                        <br />
                        <br />
                        <Divider />
                        <br />
                        <Typography variant="subtitle1">
                            Your subscription will automatically renew at the end of each {monthOrYear()}, unless cancelled. You may cancel or upgrade your subscription at any time. If you cancel midway through the {monthOrYear()}, your subscription will continue until the end of that {monthOrYear()}, but you will not be charged again.
                        </Typography>
                    </>
                    <>
                        <Paper variant="outlined" style={{ maxWidth: 550, padding: '25px 38px' }} >
                            <div >
                                <Typography variant="h6">Subscription Summary</Typography>
                            </div>
                            <Grid container  >
                                <Grid item xs={3}>
                                    <Typography style={{ padding: 7 }} variant="subtitle2">{convertTierToString(tier)}</Typography>
                                    <Typography style={{ padding: 7 }} variant="subtitle2">HST</Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography style={{ padding: 7 }} variant="subtitle2" >${price.toFixed(2)}</Typography>
                                    <Typography style={{ padding: 7 }} variant="subtitle2"  >${(price * 0.13).toFixed(2)}</Typography>
                                </Grid>
                                <Grid item xs={6} ><a target="_blank" rel="noreferrer" href='https://stripe.com/en-ca/customers'>
                                    <img style={{ maxWidth: '100%', marginTop: 11 }} alt="stripe" src="data:image/png;base64,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" />
                                </a>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={2}>
                                        <span>Cities:</span>
                                    </Grid>
                                    <Grid item xs={10}>
                                        <ul style={{ marginTop: 0 }}>
                                            {renderCityText()}
                                        </ul>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Divider />
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography style={{ padding: 7 }} variant="subtitle2"  >Total</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ padding: 7 }} variant="subtitle2" >${(price * 1.13).toFixed(2)} per {monthOrYear()}</Typography>
                                </Grid>
                                <Grid item xs={3} style={{}}>

                                    <img style={{ maxWidth: '100%', height: 40, float: 'right' }} alt="visa_mastercard" src="https://www.pngkey.com/png/detail/87-870355_carto-visa-e-master-png-clipart-visa-logo.png" />

                                </Grid>
                            </Grid>
                            <br />
                            <CardElement id="card-element" options={CARD_OPTIONS} />
                            <Button style={{ marginTop: 15 }} fullWidth onClick={handleSubmit} disabled={(tier === 1 && cities.length !== 1) || (tier === 2 && cities.length !== 3) || (subscribedClicked) || (!signedIn)} size="large" color="secondary" variant='contained'><LockIcon fontSize='small' style={{ marginRight: 8 }} />   Subscribe ${(price * 1.13).toFixed(2)}/{monthOrYear()}</Button>

                        </Paper>
                        {paymentError.er ? <div><Typography color='secondary' variant="h5" >{paymentError.mess}</Typography><Typography color='secondary' variant="h6" >Please refresh the page and try again</Typography></div> : ''}
                    </></>
                :
                <div>
                    <h2>Thank you for subscribing! Click <a href='/'>here</a> to get started. You may have to refresh your browser</h2>
                </div>
            }
        </>

    )
}


export default withRouter(Payment);
